<template>
  <div class="pk-info">
    <div class="article">
      <img class="red_limi" src="../../../../assets/img/video/pk/red_limi_1.png" alt="">
      <img class="blue_limi" src="../../../../assets/img/video/pk/blue_limi_1.png" alt="">
      <div class="class_info">
        <span>{{(!smallClassId && internal_users)?"内部班":smallClassName}}</span>
        <img src="../../../../assets/img/video/pk/vs1.png" alt="">
        <span>{{pkData.adversary_small_name}}</span>
      </div>
      <div class="progress">
        <span class="my_class" :style="{width:100+myClassWidth+'px'}">
          <i>{{pkData.team_score}}</i>
        </span>
        <img src="../../../../assets/img/video/pk/lightning.png" alt="">
        <span class="other_class" :style="{width:100+otherClassWdith+'px'}">
          <i>{{pkData.adversary_score}}</i>
        </span>
      </div>
    </div>
    <!--打成平手-->
    <p class="bubbles bubbles-left" v-show="bubblesText"><span>{{bubblesText}}</span></p>
    <p class="bubbles bubbles-right" v-show="otherBubblesText"><span>{{otherBubblesText}}!</span></p>
    <!--大家要奋起直追啊 / 厉害了，保持领先-->
    <div class="whl-tip-lottie"></div>
  </div>
</template>

<script>
import lottie from "lottie-web-limi";
import { mapState } from "vuex";
export default {
  data() {
    return {
      bubblesText: '',
      otherBubblesText: false,
      myClassWidth: 0,
      otherClassWdith: 0,
      // PK中Tip实例
      tipLottie: null
    };
  },
  props: ["pkData"],
  computed:{
     ...mapState(["smallClassName","smallClassId","internal_users"])
  },
  mounted() {
    this.initData();
    this.$emit('closeInterval',5);
  },
  methods: {
    initData(){
      const team_score = this.pkData.team_score;
      const adversary_score = this.pkData.adversary_score;
      let path = '';
      if(team_score == 0 && adversary_score == 0){
          this.myClassWidth = 118;
          this.otherClassWdith = 118;
          // return
      }else{
        const w = 236;//可用总宽度
        const totalScore = team_score + adversary_score;
        const bili = w/totalScore;
        this.myClassWidth = Math.floor(team_score * bili);
        this.otherClassWdith = w - this.myClassWidth;
      }

      if(team_score === adversary_score){ //打成平手
        this.bubblesText = "打成平手!";
        this.otherBubblesText = "打成平手!";
      }else if(team_score>adversary_score){ //厉害了，保持领先
        path = 'static/lottie/pk/lihai/index.json';
        this._showTipAnim(path)
      }else{ //大家要奋起直追啊
        path = 'static/lottie/pk/fenqi/index.json';
        this._showTipAnim(path)
      }
    },
    /**
     * PK中的Tip显示动画
     */
    _showTipAnim(path) {
      this.tipLottie = lottie.loadAnimation({
        container: document.querySelector(".whl-tip-lottie"),
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: true,
        path
      });
    }
  },

  beforeDestroy() {
    this.tipLottie && this.tipLottie.destroy();
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.pk-info {
  position: absolute;
  width: 580px;
  height: 150px;
  background: #ffffff;
  bottom: 50px;
  border-radius: 15px;
}
.article {
  width: 540px;
  height: 130px;
  margin: 0 auto;
  transform: translateY(-24px);
  img {
    width: 130px;
    z-index: 2;
    bottom: 0;
  }
  .red_limi{
    position: absolute;
    left: 0;
  }
  .blue_limi{
    position: absolute;
    right: 0;
  }
}
//打成平手
.bubbles{
  position: absolute;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size:18px;
  color: #FC8200;
  top: -92px;
  span{
    position: relative;
    z-index: 2;
    text-align: center;
    display: inline-block;
    padding: 0 20px;
    white-space: nowrap;
  }
}
.bubbles-left{
  left: 65px;
  span{
     transform: translateX(-65px);
  }
  &::before{
    content: "";
    position: absolute;
    left: -65px;
    top: -1px;
    width: 65px;
    height: 64px;
    background-image: url("../../../../assets/img/video/pk/bubbles-left.png");
    background-size: 65px 63px;
    background-repeat: no-repeat;
  }
   &::after{
    content: "";
    position: absolute;
    background-color: rgba(255,255,255,0.6);
    left: 0;
    border: 2px solid #ffffff;
    width: calc(100% - 65px);
    border-radius: 0 28px 28px 0;
    border-left: none;
    height: 51px;
  }
}
.bubbles-right{
  right:0;
  &::before{
    content: "";
    position: absolute;
    right: -2px;
    width: 65px;
    height: 64px;
    background-image: url("../../../../assets/img/video/pk/bubbles-right.png");
    background-size: 65px 63px;
    background-repeat: no-repeat;
  }
   &::after{
    content: "";
    position: absolute;
    background-color: rgba(255,255,255,0.6);
    left: 0;
    border: 2px solid #ffffff;
    width: calc(100% - 65px);
    border-radius:  28px 0 0 28px;
     border-right: none;
    height: 52px;
  }
}
.whl-tip-lottie {
  position: absolute;
  height: 130px;
  width: 185px;
  text-align: left;
  top: -144px;
  left: -20px;
}
.class_info{
  width: 270px;
  padding-top: 45px;
  margin:0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img{
    width:65px;
  }
  span{
    display:inline-block;
    font-size: 16px;
    width:86px;
    white-space: nowrap;
    overflow: hidden;
    line-height: 30px;
    &:first-child{
      color: #7E0D00;
      text-align: left;
    }
    &:last-child{
      color:#002680;
      text-align: right;
    }
  }
}
.progress{
  height: 41px;
  width: 436px;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left:-217px;
  z-index: 1;
  text-align: left;
  font-size: 0;
  img{
    width: 24px;
    position: absolute;
    margin-left:-12px;
  }
  span{
    min-width: 100px;
    height: 100%;
    line-height: 41px;
  }
  i{
    font-size:20px;
    color: #FFFFFF;
    background-image: url("../../../../assets/img/common/energy.png");
    background-size: 20px;
    background-repeat: no-repeat;
    background-position:left center ;
  }
  .my_class{
    background: linear-gradient(180deg,#ff6f4f, #e54836 61%, #e65140);
    box-shadow: 0px 1px 2px 0px rgba(255,255,255,0.5) inset;
    padding-left: 30px;
    text-align: left;
    float: left;
    i{
      padding-left: 22px;
    }
  }
  .other_class{
    background: linear-gradient(180deg,#5b98ec, #3f6fe0 59%, #3668dd);
    box-shadow: 0px 1px 2px 0px rgba(255,255,255,0.5) inset;
    text-align: right;
    float: right;
    padding-right: 30px;
    i{
      padding-left: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/pk/pkInfo.vue